import { AxiosRequestConfig } from 'axios';
import client from '../client';

export function get(id: number, candidate_id?: number, customConfig?: AxiosRequestConfig) {
    const url = `/calendar/${id}` + (candidate_id ? `?candidate_id=${candidate_id}` : '');
    return client.get(url, customConfig);
}
